import { useState } from 'react'
import { OPPORTUNITY_STATUS_ID } from 'shared'
import type { OpportunityStatusState } from '../-components/OpportunityStatusSelect'

interface StatusEntry {
  id: number
  is_completed: boolean
}

export function useOpportunityStatusFormState(initialState: OpportunityStatusState, statuses: StatusEntry[]) {
  const [statusState, setStatusState] = useState<OpportunityStatusState>(initialState)
  const [touched, setTouched] = useState<Record<string, boolean>>({})

  const handleStatusChange = (newStatusId: string) => {
    const id = Number.parseInt(newStatusId, 10)
    const newStatus = statuses.find((s) => s.id === id)

    const newCloseReasonId = newStatus?.is_completed ? statusState.closeReasonId : null
    const newAdditionalCloseReason = newStatus?.is_completed ? statusState.additionalCloseReason : ''
    const newGCompanyName = id === OPPORTUNITY_STATUS_ID.G_COMPANY_STATUS_ID ? statusState.gCompanyName : ''
    const newGCompanyContact = id === OPPORTUNITY_STATUS_ID.G_COMPANY_STATUS_ID ? statusState.gCompanyContact : ''

    setStatusState({
      statusId: id,
      closeReasonId: newCloseReasonId,
      additionalCloseReason: newAdditionalCloseReason,
      gCompanyName: newGCompanyName,
      gCompanyContact: newGCompanyContact,
    })
    setTouched((prev) => ({
      ...prev,
      closeReason: false,
      additionalCloseReason: false,
      gCompanyName: false,
      gCompanyContact: false,
    }))
  }

  const handleCloseReasonChange = (newReasonId: string) => {
    const id = Number.parseInt(newReasonId, 10)
    setStatusState((prev) => ({
      ...prev,
      closeReasonId: id,
      additionalCloseReason: '',
    }))
    setTouched((prev) => ({ ...prev, closeReason: true, additionalCloseReason: false }))
  }

  const handleAdditionalCloseReasonChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setStatusState((prev) => ({ ...prev, additionalCloseReason: e.target.value }))
    setTouched((prev) => ({ ...prev, additionalCloseReason: true }))
  }

  const handleGCompanyNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setStatusState((prev) => ({ ...prev, gCompanyName: e.target.value }))
    setTouched((prev) => ({ ...prev, gCompanyName: true }))
  }

  const handleGCompanyContactChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setStatusState((prev) => ({ ...prev, gCompanyContact: e.target.value }))
    setTouched((prev) => ({ ...prev, gCompanyContact: true }))
  }

  const touchAllStatusFields = () => {
    setTouched({
      closeReason: true,
      additionalCloseReason: true,
      gCompanyName: true,
      gCompanyContact: true,
    })
  }

  return {
    statusState,
    touched,
    handleStatusChange,
    handleCloseReasonChange,
    handleAdditionalCloseReasonChange,
    handleGCompanyNameChange,
    handleGCompanyContactChange,
    touchAllStatusFields,
  }
}
